import classnames from "classnames";
import { useEffect, useRef } from "react";
import Button, { SIZE, STYLE } from "components/Button";
import { ArrowBack } from "components/assets/Icons";

import styles from "./ContentHeader.module.scss";

const ContentHeader = ({
  title,
  className,
}) => {
  const refContentHeader = useRef();

  function setContentHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--content-header-height",
        `${refContentHeader.current?.offsetHeight}px`
      );
    }
  }

  useEffect(() => {
    setContentHeaderHeight();
  }, [title]);

  return (
    <div
      className={classnames(styles.wrapper, className)}
      ref={refContentHeader}
    >
      <h3 className={styles.title}>{title}</h3>      
    </div>
  );
};

export default ContentHeader;
